import { convertSSToMMSS } from '../../../utils/time';
import { keysToCamelCase, removeUndefinedValues } from '../../../utils/object';
import { normalizeId } from '../../../utils/normalize-id';

import transcodingStatuses from '../../../constants/transcoding-statuses';
import freeDealInfo from '../../../constants/free-deal-info';
import videoSources from '../../../constants/video-sources';


export default function (adapterMethods, itemData) {

  if (!itemData) {
    return null;
  }

  itemData = keysToCamelCase(itemData);

  const {
    itemId,
    externalId,
    listId,
    mediaStatus,
    trailerStatus,
    mediaInfo,
    mediaExternUrl,
    videoSource = videoSources.COMPUTER,
  } = itemData;

  const id = (itemId && normalizeId(itemId)) || externalId;

  let {
    customCoverUrl,
    createdTs,
    updatedTs,
    publishTs,
    dealInfo,
    usedInLists,
    durationSec,
    durationStr,
    tags = [],
    categories = [],
  } = itemData;

  customCoverUrl = customCoverUrl || null;

  createdTs = new Date(createdTs * 1000);
  updatedTs = new Date(updatedTs * 1000);
  if (publishTs) {
    publishTs = new Date(publishTs * 1000);
  }

  usedInLists = _.map(usedInLists, ({ itemId, title }) => ({
    id: itemId,
    title,
  }));

  const fileInputDurationSec = _.get(mediaInfo, 'fileInput.duration', 0);
  if (fileInputDurationSec) {
    durationSec = Math.floor(fileInputDurationSec / 1000);
    durationStr = convertSSToMMSS(durationSec);
  }
  if (!durationStr) {
    durationStr = convertSSToMMSS(durationSec);
  }

  const getVideoUrls = _.partial(adapterMethods.item.getVideoUrls, _.noop, itemId);
  const getVideoUrlsByFileName = _.partial(adapterMethods.item.getVideoUrlsByFileName, _.noop);

  const transcodingStatus = mediaExternUrl ?
    transcodingStatuses.READY :
    (mediaStatus || transcodingStatuses.NONE);

  // external videos should be free
  if (mediaExternUrl) {
    dealInfo = freeDealInfo;
  }

  tags = _.uniq(tags);
  categories = _.uniq(categories);

  // TODO: add mapping instead assign
  itemData = _({})
    .assign(itemData, {
      id,
      listId: normalizeId(listId),
      customCoverUrl,
      transcodingStatus,
      trailerTranscodingStatus: trailerStatus || transcodingStatuses.NONE,
      dealInfo,
      durationSec,
      durationStr,
      createdTs,
      updatedTs,
      publishTs,
      usedInLists,
      getVideoUrls,
      getVideoUrlsByFileName,
      videoSource,
      tags,
      categories,
    })
    .omit('itemId', 'mediaStatus', 'trailerStatus')
    .value();

  return removeUndefinedValues(itemData);
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/parsers/item.js